export default "__VITE_ASSET__BuZEFtpL__"